import React from 'react';
import loadable from '@loadable/component';

import { Helpers } from '../core/src/helpers';

const NotFoundPage = loadable(() => Helpers.retryFunc(() => import('./not-found-container')));

const NotFoundContainer = props => {
    return <NotFoundPage {...props} />;
};

export default NotFoundContainer;
